export enum TipoLocalEnum {
    InstalacaoTecnica = 1,
    InstalacaoTecnicaDescription = 'IT',
    LocalSecundario = 2,
    LocalSecundarioDescription = 'ITS',
    LocalProvisorio = 3,
    LocalProvisorioDescription = 'PP'
}
